const CONFLICTING_MEETINGS_ADDITIONAL_PROPERTIES_KEYS: string[] = [
    'ConflictingMeetings',
    'ConflictingMeetingCount',
].sort();

const ADJACENT_MEETINGS_ADDITIONAL_PROPERTIES_KEYS: string[] = [
    'AdjacentMeetings',
    'AdjacentMeetingCount',
].sort();

const BASIC_MEETING_ADDITIONAL_PROPERTIES_KEYS: string[] = [
    'Start',
    'End',
    'CalendarItemType',
    'Organizer',
    'Subject',
].sort();

const MEETING_MAIL_ADDITIONAL_PROPERTIES_KEYS: string[] = [
    'AssociatedCalendarItemId',
    'ItemClass',
    'MeetingRequestType',
    'Sender',
    'ConversationId',
    'ReceivedRepresenting',
    'ItemParentId',
    'ChangeHighlights',
].sort();

const CALENDAR_EVENT_SPECIAL_PROPERTIES_KEYS: string[] = [
    'RecurrenceId',
    'Recurrence',
    'IsResponseRequested',
    'IsDelegated',
    'ResponseType',
].sort();

const ALL_MEETING_PROPERTIES_KEYS: string[] = [
    ...CONFLICTING_MEETINGS_ADDITIONAL_PROPERTIES_KEYS,
    // ...ADJACENT_MEETINGS_ADDITIONAL_PROPERTIES_KEYS, // Unused so far
    ...BASIC_MEETING_ADDITIONAL_PROPERTIES_KEYS,
    ...MEETING_MAIL_ADDITIONAL_PROPERTIES_KEYS,
    ...CALENDAR_EVENT_SPECIAL_PROPERTIES_KEYS,
].sort();

/**
 * This returns the strings of the additional Properties which are needed by the server to get conflict meeting info
 */
export const getConflictingMeetingsInfoAdditionalProperties = () =>
    CONFLICTING_MEETINGS_ADDITIONAL_PROPERTIES_KEYS;

/**
 * This returns the strings of the additional Properties which are needed by the server to get adjacent meeting info
 */
export const getAdjacentMeetingsInfoAdditionalProperties = () =>
    ADJACENT_MEETINGS_ADDITIONAL_PROPERTIES_KEYS;

/**
 * This returns the strings of the additional Properties which are needed by the server to get calendar event special info
 */
export const getCalendarEventSpecialProperties = () => CALENDAR_EVENT_SPECIAL_PROPERTIES_KEYS;

/**
 * This returns the strings of the additional Properties which are needed by the server to get info related to the mail representing a meeting
 */
export const getMeetingMailAdditionalProperties = () => MEETING_MAIL_ADDITIONAL_PROPERTIES_KEYS;

/**
 * This returns the strings of the additional Properties which are needed by the server to get basic meeting event info
 */
export const getBasicMeetingAdditionalProperties = () => BASIC_MEETING_ADDITIONAL_PROPERTIES_KEYS;

/**
 * This returns all the keys required in the item response shape related to an event
 */
export const getAllMeetingProperties = () => ALL_MEETING_PROPERTIES_KEYS;
